// extracted by mini-css-extract-plugin
export default {"wrapper":"o4N28lCAFJrZjBYNFTL2","freezeBtn":"h2U4eJYIUO4nBpZao7X7","freezeBtnActiveIcon":"zEa2AFPcEsRJ_qNiRMag"};